export default "__VITE_ASSET__Ds29UaQk__"